module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar disabled = model.disabled;\nvar additionalClasses = [];\nif(typeof(additionalCSSClass) !== 'undefined'){\nadditionalClasses.push(additionalCSSClass);\n}\nif(model.additionalCSSClass) {\nadditionalClasses.push(model.additionalCSSClass);\n}\nif(typeof(forceDisabled) === 'undefined'){\nforceDisabled = false;\n}\nif(model.forceDisabled){\nforceDisabled = true;\n}\n%>\n<select class=\"<%- additionalClasses.join(' ') %>\" data-field-type=\"select\" data-field-code=\"<%= model.fieldCode %>\"<%= (disabled || forceDisabled ? ' DISABLED' : '') %>>\n<%#- JSON.stringify(formMapping); %>\n<%#- JSON.stringify(storage); %>\n<%#- JSON.stringify(model); %>\n<%\n// prepare config\nvar renderConfig = model.config && model.config.renderConfig ? model.config.renderConfig : {};\nvar groupConfig = renderConfig.groupEntries || {};\ngroupConfig = utils.replace({ children: 'children', valuePrefix: '' }, groupConfig);\nvar childConfig = renderConfig.optionEntries || {};\nchildConfig = utils.replace({ value: 'value', name: 'name' }, childConfig);\nvar isGrouped = !!groupConfig.name;\n// prepare user-lang\nvar langCode;\nif(storage.user && storage.user.data && storage.user.data.langCode){\nlangCode = storage.user.data.langCode;\n}\n// prepare source-data-flag\nvar dataAttributeKey;\nif(!!model.atom && !!model.atom.dataType){\ndataAttributeKey = model.atom.dataType + '-data';\n} else {\ndataAttributeKey = 'data';\n}\n// prepare options\nvar options = [];\nif(Array.isArray(model[dataAttributeKey])){\noptions = model[dataAttributeKey];\n}\nelse if(!!model[dataAttributeKey] && !!model[dataAttributeKey].options){\noptions = model[dataAttributeKey].options;\n}\n// prepare default entry\nif(renderConfig.defaultOptionEntry){\nvar entry = {};\nif(langCode && renderConfig.defaultOptionEntry.lang && renderConfig.defaultOptionEntry.lang[langCode]){\nentry[childConfig.name] = renderConfig.defaultOptionEntry.lang[langCode];\nentry[childConfig.value] = renderConfig.defaultOptionEntry.value;\n}\nelse {\nentry[childConfig.name] = renderConfig.defaultOptionEntry.name;\nentry[childConfig.value] = renderConfig.defaultOptionEntry.value;\n}\noptions.unshift(entry);\n}\nif(!!options){\n//        {\n//            \"groupEntries\": {\n//                  \"name\": \"path\",\n//                  \"selectable\": false,\n//                  \"valuePrefix\": \"routeID\"\n//            }\n//        }\nvar groupFound = false;\nvar optionValue;\nvar optionName;\nvar optionSelected;\nvar optionConfig;\nvar firstOptionInCharge = true;\n%>\n<%#-JSON.stringify({ groupConfig: groupConfig, childConfig: childConfig, data: model[dataAttributeKey] })%>\n<%\nutils.forEach(options, function(option, optionIndex){\nchildConfig.valuePrefix = '';\nif((groupFound = (isGrouped && option[groupConfig.children]))){\nif(groupConfig.value && option[groupConfig.value]){\nchildConfig.valuePrefix = option[groupConfig.value] + '_';\n}\nif(groupConfig.selectable) {\noption[groupConfig.children].unshift(option);\n}\nelse {\n%>\n<%# define optionGroups' html-code %>\n<optgroup label=\"<%- (groupConfig.name && option[groupConfig.name] ? option[groupConfig.name] : '-NO-NAME-FOUND-') %>\">\n<%\n}\n}\nutils.forEach(groupFound ? option[groupConfig.children] : [option], function(child, childIndex){\n// estimate right config for the actual child\nif(firstOptionInCharge && renderConfig.defaultOptionEntry)  optionConfig = childConfig;\nelse if(childIndex == 0 && groupConfig.selectable)          optionConfig = groupConfig;\nelse                                                        optionConfig = childConfig;\n// define option name\nif(!!child.lang && !!child.lang[storage.user.data.langCode] && !!child.lang[storage.user.data.langCode][optionConfig.name]){\noptionName = child.lang[storage.user.data.langCode][optionConfig.name];\n} else if (!!child[optionConfig.name]) {\noptionName = child[optionConfig.name];\n} else {\noptionName = '-NO-NAME-FOUND-';\n}\n// define options' value\noptionValue = optionConfig.valuePrefix + child[optionConfig.value];\n// define if option is selected\nif(Array.isArray(model.dataJSON)) {\noptionSelected = utils.indexOf(model.dataJSON, optionValue) >= 0;\n} else if(model.dataJSON !== undefined){\noptionSelected = model.dataJSON === optionValue;\n} else if(model.dataTEXT != undefined && model.atom.dataType === 'template-picker'){\noptionSelected = optionValue == model.dataTEXT;\n} else if(model.dataTIME != undefined && model.atom.dataType === 'time'){\noptionSelected = optionValue == model.dataTIME;\n} else {\noptionSelected = !!child.defaultSelected;\n}\nif(child[optionConfig.value] === null){\n%><option value<%= (optionSelected ? ' SELECTED' : '') %>><%= optionName %></option><%\n} else {\n%><option value=\"<%- optionValue %>\"<%= (optionSelected ? ' SELECTED' : '') %>><%= optionName %></option><%\n}\n});\nif(groupFound && !groupConfig.selectable){\n%>\n</optgroup>\n<%\n}\nfirstOptionInCharge = false;\n});\n}\n%>\n</select>"
  , __filename = "node_modules/frontend-controller/baseComponents/form/fields/select.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var disabled = model.disabled;
var additionalClasses = [];
if(typeof(additionalCSSClass) !== 'undefined'){
additionalClasses.push(additionalCSSClass);
}
if(model.additionalCSSClass) {
additionalClasses.push(model.additionalCSSClass);
}
if(typeof(forceDisabled) === 'undefined'){
forceDisabled = false;
}
if(model.forceDisabled){
forceDisabled = true;
}

    ; __line = 16
    ; __append("\n<select class=\"")
    ; __line = 17
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-field-type=\"select\" data-field-code=\"")
    ; __append(escapeFn( model.fieldCode ))
    ; __append("\"")
    ; __append(escapeFn( (disabled || forceDisabled ? ' DISABLED' : '') ))
    ; __append(">\n")
    ; __line = 18
    ; __append("\n")
    ; __line = 19
    ; __append("\n")
    ; __line = 20
    ; __append("\n")
    ; __line = 21
    ; 
// prepare config
var renderConfig = model.config && model.config.renderConfig ? model.config.renderConfig : {};
var groupConfig = renderConfig.groupEntries || {};
groupConfig = utils.replace({ children: 'children', valuePrefix: '' }, groupConfig);
var childConfig = renderConfig.optionEntries || {};
childConfig = utils.replace({ value: 'value', name: 'name' }, childConfig);
var isGrouped = !!groupConfig.name;
// prepare user-lang
var langCode;
if(storage.user && storage.user.data && storage.user.data.langCode){
langCode = storage.user.data.langCode;
}
// prepare source-data-flag
var dataAttributeKey;
if(!!model.atom && !!model.atom.dataType){
dataAttributeKey = model.atom.dataType + '-data';
} else {
dataAttributeKey = 'data';
}
// prepare options
var options = [];
if(Array.isArray(model[dataAttributeKey])){
options = model[dataAttributeKey];
}
else if(!!model[dataAttributeKey] && !!model[dataAttributeKey].options){
options = model[dataAttributeKey].options;
}
// prepare default entry
if(renderConfig.defaultOptionEntry){
var entry = {};
if(langCode && renderConfig.defaultOptionEntry.lang && renderConfig.defaultOptionEntry.lang[langCode]){
entry[childConfig.name] = renderConfig.defaultOptionEntry.lang[langCode];
entry[childConfig.value] = renderConfig.defaultOptionEntry.value;
}
else {
entry[childConfig.name] = renderConfig.defaultOptionEntry.name;
entry[childConfig.value] = renderConfig.defaultOptionEntry.value;
}
options.unshift(entry);
}
if(!!options){
//        {
//            "groupEntries": {
//                  "name": "path",
//                  "selectable": false,
//                  "valuePrefix": "routeID"
//            }
//        }
var groupFound = false;
var optionValue;
var optionName;
var optionSelected;
var optionConfig;
var firstOptionInCharge = true;

    ; __line = 76
    ; __append("\n")
    ; __line = 77
    ; __append("\n")
    ; __line = 78
    ; 
utils.forEach(options, function(option, optionIndex){
childConfig.valuePrefix = '';
if((groupFound = (isGrouped && option[groupConfig.children]))){
if(groupConfig.value && option[groupConfig.value]){
childConfig.valuePrefix = option[groupConfig.value] + '_';
}
if(groupConfig.selectable) {
option[groupConfig.children].unshift(option);
}
else {

    ; __line = 89
    ; __append("\n")
    ; __line = 90
    ; __append("\n<optgroup label=\"")
    ; __line = 91
    ; __append( (groupConfig.name && option[groupConfig.name] ? option[groupConfig.name] : '-NO-NAME-FOUND-') )
    ; __append("\">\n")
    ; __line = 92
    ; 
}
}
utils.forEach(groupFound ? option[groupConfig.children] : [option], function(child, childIndex){
// estimate right config for the actual child
if(firstOptionInCharge && renderConfig.defaultOptionEntry)  optionConfig = childConfig;
else if(childIndex == 0 && groupConfig.selectable)          optionConfig = groupConfig;
else                                                        optionConfig = childConfig;
// define option name
if(!!child.lang && !!child.lang[storage.user.data.langCode] && !!child.lang[storage.user.data.langCode][optionConfig.name]){
optionName = child.lang[storage.user.data.langCode][optionConfig.name];
} else if (!!child[optionConfig.name]) {
optionName = child[optionConfig.name];
} else {
optionName = '-NO-NAME-FOUND-';
}
// define options' value
optionValue = optionConfig.valuePrefix + child[optionConfig.value];
// define if option is selected
if(Array.isArray(model.dataJSON)) {
optionSelected = utils.indexOf(model.dataJSON, optionValue) >= 0;
} else if(model.dataJSON !== undefined){
optionSelected = model.dataJSON === optionValue;
} else if(model.dataTEXT != undefined && model.atom.dataType === 'template-picker'){
optionSelected = optionValue == model.dataTEXT;
} else if(model.dataTIME != undefined && model.atom.dataType === 'time'){
optionSelected = optionValue == model.dataTIME;
} else {
optionSelected = !!child.defaultSelected;
}
if(child[optionConfig.value] === null){

    ; __line = 123
    ; __append("<option value")
    ; __append(escapeFn( (optionSelected ? ' SELECTED' : '') ))
    ; __append(">")
    ; __append(escapeFn( optionName ))
    ; __append("</option>")
    ; 
} else {

    ; __line = 125
    ; __append("<option value=\"")
    ; __append( optionValue )
    ; __append("\"")
    ; __append(escapeFn( (optionSelected ? ' SELECTED' : '') ))
    ; __append(">")
    ; __append(escapeFn( optionName ))
    ; __append("</option>")
    ; 
}
});
if(groupFound && !groupConfig.selectable){

    ; __line = 129
    ; __append("\n</optgroup>\n")
    ; __line = 131
    ; 
}
firstOptionInCharge = false;
});
}

    ; __line = 136
    ; __append("\n</select>")
    ; __line = 137
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/form/fields/select.ejs

}